import { PropsWithChildren } from 'lib-shared-types-utils';
import { MouseEventHandler } from 'react';

import { AppLink } from 'components/appLink';

export type UserLinkProps = {
  /** The id of the user used to link to the contact page */
  userId: string;
  /** Optional click handler on the anchor, e.g. to stop a parent card from toggling. */
  onClick?: MouseEventHandler<HTMLAnchorElement>;
} & PropsWithChildren;

export const UserLink = ({
  userId,
  children,
  onClick,
}: UserLinkProps): JSX.Element => {
  return (
    <AppLink
      path={`/contacts/user/:id`}
      params={{ path: { id: userId } }}
      onClick={onClick}
    >
      {children}
    </AppLink>
  );
};
